<div *ngIf="loading">
    <div class="col-12 md:col-6 col-offset-6">
        <span style="font-size:medium;">{{'SHIPMENT.LABEL.LOADINGLABELSTEXT' | translate}}</span>
    </div>
    <p-progressBar mode="indeterminate" styleClass="ui-progressbar-custom-indeterminate"></p-progressBar>
</div>

<div *ngIf="pdfBlobUrl">
    <object [data]="pdfBlobUrl" type="application/pdf" style="width:100%; height:70vh;">
        <a [href]="pdfBlobUrl">Print.pdf</a>
    </object>
</div>